import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BlogListCard from "../../components/BlogListCard/BlogListCard";
import Footer from "../../components/footer/Footer";
import Banner from "../../components/banner/banner";
import { EXPERTISEBG } from "../../assets/images";
import blogPosts from "./blogData";
import "./blog.css";
import "../digital/digital.css";

const getPostDateValue = (dateString) => {
  const parsedDate = Date.parse(dateString);
  return Number.isNaN(parsedDate) ? 0 : parsedDate;
};

const Blog = () => {
  const sortedBlogPosts = [...blogPosts].sort(
    (a, b) => getPostDateValue(b.date) - getPostDateValue(a.date),
  );

  return (
    <>
      <div className="blog_page">
        <Banner
          className="blog_banner"
          title="Insights & Blog"
          bg={EXPERTISEBG}
        />

        <Container className="blog_intro">
          <div className="digital_section_title">
            <h3>
              Explore the latest trends, insights, and innovations from the
              Elverve team.
            </h3>
          </div>
        </Container>

        <Container className="blog_container">
          <Row className="g-4">
            {sortedBlogPosts.map((post) => (
              <Col key={post.slug} md={6} lg={4}>
                <BlogListCard {...post} />
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Blog;
